import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChecklistTypePipe } from './checklist-type.pipe';

@NgModule({
  declarations: [
    ChecklistTypePipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    ChecklistTypePipe
  ]
})
export class ChecklistTypeModule { }
